import React from 'react';
import { useParams } from 'react-router';
import { useEnvironments } from 'services/useEnvironments';
import { useSelectedEnvironment } from 'services/useSelectedEnvironment';
import { useSelectedProject } from 'services/useSelectedProject';
import { CameraLayoutSettingPage, CameraLayoutSettingPageProps } from './CameraLayoutSettingPage';

export type SettingsPageProps = Omit<CameraLayoutSettingPageProps, 'vehicleId' | 'projectId' | 'environmentId'>;

export function SettingsPage(props: SettingsPageProps) {
    const { vehicleId } = useParams<{ vehicleId: string }>();
    if (vehicleId === undefined) throw Error('missing vehicle ID in URL');

    const project = useSelectedProject();
    const projectId = project ? project.id : undefined;
    const environments = useEnvironments(projectId);
    const environmentId = useSelectedEnvironment(environments)?.id;

    if (!projectId || !environmentId) {
        return <p>Please select project and environment</p>;
    }

    return <CameraLayoutSettingPage {...props} projectId={projectId} environmentId={environmentId} vehicleId={vehicleId} />;
}
